
import { PATH_DASHBOARD } from '../routes/paths';
import {
    StyleSheet
  } from "@react-pdf/renderer";
import Label from '../components/Label';
import SvgIconStyle from '../components/SvgIconStyle';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
var prod = true;  // false for dev

// stripe api key
export const stripePublicKey = prod? 'pk_live_iBqKVFC4XkYCfqK2K3snMMqH00aRkpJ2Tf': 'pk_test_OAVrFzSydPj8LimFPtM2ndGq00Rc12FA2i'; // based on env

// socket
export const socketServerUrl = prod? 'https://wesafe.com.au:8666': 'https://wesafe.com.au:8686'; // based on env

// rest api
export const serverBaseUrl = prod? 'https://wesafe.com.au:8555': 'https://wesafe.com.au:8585'; // based on env

const getIcon = (name) => (
    <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);
const getIcon2 = (name) => (
    <AttachMoneyIcon  sx={{ width: '100%', height: '100%' }} />
);
const getIcon3 = (name) => (
    <LocationOnIcon  sx={{ width: '100%', height: '100%' }} />
);
const getIcon4 = (name) => (
    <BusinessIcon  sx={{ width: '100%', height: '100%' }} />
);

export const monthlyMembershipPrice = 47;
export const yearlyMembershipPrice = 508;

export const userStatus = {
    online: 'online',
    offline: 'offline'
}

export const checkIfMobile= ()=>{
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

export const getStatus = (userId, onlineUsers)=> onlineUsers[userId] ? userStatus.online : userStatus.offline;
let months = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
}
// export const FDate = (date)=>  new Date(date).toDateString();
export const FDate = (date)=>{
    let d = new Date(date);
    return d.getDate()+'-'+months[d.getMonth()+1]+'-'+d.getFullYear();
}

export const screenOptions = {mobileLimit: 990, tabletLimit: 800}

function treatAsUTC(date) {
    var result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
}

function daysBetween(startDate, endDate) {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}
export const checkIfExpired = (expiryDate)=>{
	if(!expiryDate){
		return false;
	}
	let current = new Date();
	let endDate = new Date(expiryDate);


	current = current / 1000;
	endDate = endDate / 1000;

	if(current >= endDate){
		return true;
	}else{
		return false;
	}
}

export const isTrialing = (date)=>{
	var days = daysBetween(date, new Date());
    if(days>=30) return false;
    else return true;
}

export const jobsiteStatus = {
    '0': 'Under Construction',
    '1': 'completed'
}
export const userRoles = {
    normal: 10,
    admin: 1,
    builder: 2,
    subcontractor: 3,
    employee: 4,
    officeadmin: 5,
    supervisor: 6,
    storeAdmin: 7
}
export const userRoleNames = {
    "10": "Onboarding Not Completed",
    "1": "Admin",
    "2": "Builder",
    "3": "Subcontractor",
    "4": "Employee",
    "5": "Officeadmin",
    "6": "Supervisor",
    "7": "Store Admin",
}
export const commonDocs = ['cards','licenses','insurances','workCovers','testTag','ewpCards','workingHeightsCards','professions'];
export const userDocs = {
    1: [],
    2: [...commonDocs, 'ptc', 'whs', 'wir'], //builder docs
    3: [...commonDocs], // subocntractor docs
    4: [...commonDocs], // employee docs
    5: [...commonDocs, 'ptc', 'whs', 'wir'], // office admin docs
    6: [...commonDocs] // supervisor docs
}



export const skipableDocs = {
    1: {},
    2: {},
    3: {
        workCovers: {name: 'workCoverSkipped'},
        testTag: {name: 'testtagSkipped'},
        licenses: {name: 'qbccSkipped'},
    },
    4: {
        cards: {name: 'blueCardSkipped'},
        workingHeightsCards: {name: 'workingHeightsCardSkipped'},
        ewpCards: {name: 'ewpCardSkipped'},
        testTag: {name: 'testtagSkipped'},
    },
    5: {},
    6: {
        licenses: {name: 'qbccSkipped'},
        workingHeightsCards: {name: 'workingHeightsCardSkipped'},
        ewpCards: {name: 'ewpCardSkipped'},
    }
}

export const commonDocsTable = [
    {
        name: 'White/Blue Card',
        tableName: 'cards'
    },
    {
        name: 'QBCC License',
        tableName: 'licenses'
    },
    {
        name: 'Public Liability Insurance',
        tableName: 'insurances'
    },
    {
        name: 'Work Cover',
        tableName: 'workCovers'
    },
    {
        name: 'Test & Tag',
        tableName: 'testTag'
    },
    {
        name: 'EWP License',
        tableName: 'ewpCards'
    },
    {
        name: 'Working Heights License',
        tableName: 'workingHeightsCards'
    },
]

export const userNewDocs = {
    1: [],
    2: [
        ...commonDocsTable,
        {
            name: 'SWMS',
            tableName: 'professions'
        },
        {
            name: 'Period Trade Contract',
            tableName: 'userDocs',
            type: 'ptc'
        },
        {
            name: 'Workplace Health and Safety Management Plan',
            tableName: 'userDocs',
            type: 'whs'
        }
    ],
    3: [
        ...commonDocsTable,
        {
            name: 'SWMS',
            tableName: 'professions'
        },
    ],
    4: [
        ...commonDocsTable,

    ],
    5: [
        ...commonDocsTable,
        {
            name: 'SWMS',
            tableName: 'professions'
        },
        {
            name: 'Period Trade Contract',
            tableName: 'userDocs',
            type: 'ptc'
        },
        {
            name: 'Workplace Health and Safety Management Plan',
            tableName: 'userDocs',
            type: 'whs'
        }
    ],
    6: [
        
        ...commonDocsTable,
        {
            name: 'SWMS',
            tableName: 'professions'
        },
    ],
    7: []
}

const ICONS = {
    blog: getIcon('ic_blog'),
    cart: getIcon('ic_cart'),
    chat: getIcon('ic_chat'),
    mail: getIcon('ic_mail'),
    user: getIcon('ic_user'),
    user2: getIcon2('ic_user2'),
    kanban: getIcon('ic_kanban'),
    banking: getIcon('ic_banking'),
    calendar: getIcon('ic_calendar'),
    ecommerce: getIcon('ic_ecommerce'),
    jobsite: getIcon3(''),
    dashboard: getIcon('ic_dashboard'),
    booking: getIcon('ic_booking'),
    builder: getIcon4('')
  };

export const documentStyle = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      backgroundColor: 'tomato'
    },
    title: {
      fontSize: 24,
      textAlign: "center",
      fontFamily: "Oswald"
    },
    author: {
      fontSize: 12,
      textAlign: "center",
      marginBottom: 40
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      marginLeft: 0,
      marginTop: 0,
      fontWeight: 'bold',
      color: 'grey',
      fontFamily: "Oswald"
    },
    text: {
      margin: 12,
      marginBottom: 0,
      fontSize: 14,
      textAlign: "justify",
      fontFamily: "Times-Roman"
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: "center",
      color: "grey"
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey"
    }
});

export const arrangeDocIndexes = sections=>{
    var count = 0;
    sections.map(section=>{
          if(section.title && section.title.length>0){
              section.index = ++count;
          }
      })
    return sections;
}

export const periodTradeContract = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;
export const wsfPlan = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;
export const wirPlan = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;

export const menuConfig = {
    "10": { // this is role id
        subheader: 'Normal',
        items: [ // these are menu items with child menus as well
            // {
            //     title: 'company pulse',
            //     path: PATH_DASHBOARD.general.analytics,
            //     icon: ICONS.dashboard
            // },
            // { title: 'users', path: PATH_DASHBOARD.user.root, icon: ICONS.user,
            //     children: [
            //     { title: 'Builders', path: PATH_DASHBOARD.user.list },
            //     { title: 'Subcontractors', path: PATH_DASHBOARD.user.list2 },
            //     { title: 'Workers', path: PATH_DASHBOARD.user.list3 }
            //     ]
            // },
            // { title: 'subscriptions', path: PATH_DASHBOARD.user.root, icon: ICONS.user2,
            //     children: [
            //     { title: 'All', path: PATH_DASHBOARD.user.list },
            //     { title: 'Active', path: PATH_DASHBOARD.user.list },
            //     { title: 'Unactive', path: PATH_DASHBOARD.user.list }
            //     ]
            // },
            // { title: 'Job Sites', path: PATH_DASHBOARD.eCommerce.shop, icon: ICONS.jobsite },

        ]
    },
    "1": { // this is role id
        subheader: 'Admin',
        items: [ // these are menu items with child menus as well
            // {
            //     title: 'company pulse',
            //     path: PATH_DASHBOARD.general.analytics,
            //     icon: ICONS.dashboard
            // },
            // { title: 'users', path: PATH_DASHBOARD.user.root, icon: ICONS.user,
            //     children: [
            //     { title: 'Builders', path: PATH_DASHBOARD.user.list },
            //     { title: 'Subcontractors', path: PATH_DASHBOARD.user.list2 },
            //     { title: 'Workers', path: PATH_DASHBOARD.user.list3 }
            //     ]
            // },
            // { title: 'subscription', path: PATH_DASHBOARD.user.root, icon: ICONS.user2,
            //     children: [
            //     { title: 'All', path: PATH_DASHBOARD.user.list },
            //     { title: 'Active', path: PATH_DASHBOARD.user.list },
            //     { title: 'Unactive', path: PATH_DASHBOARD.user.list }
            //     ]
            // },
            // { title: 'Job Sites', path: PATH_DASHBOARD.user.jobsites, icon: ICONS.jobsite },

            { title: 'Documents', path: PATH_DASHBOARD.documentsIndex, icon: ICONS.dashboard,
                children: [
                    { title: 'PTC', path: PATH_DASHBOARD.ptcDocument },
                    { title: 'WHS', path: PATH_DASHBOARD.whsDocument },
                    // { title: 'Wir', path: PATH_DASHBOARD.wirDocument },
                    { title: 'SWMS', path: PATH_DASHBOARD.swmsDocument },
                    { title: 'Hazardous Substances', path: PATH_DASHBOARD.hazardousSubstances },
					 { title: 'Terms & Conditions', path: PATH_DASHBOARD.termsAndConditions }
                ]
            },
            // { title: 'Old Documents', path: PATH_DASHBOARD.documentsIndex, icon: ICONS.dashboard,
            //     children: [
            //         { title: 'PTC', path: PATH_DASHBOARD.oldPtcDocument },
            //         { title: 'WHS', path: PATH_DASHBOARD.oldWhsDocument },
            //         { title: 'Wir', path: PATH_DASHBOARD.oldWirDocument }
            //     ]
            // },
            { title: 'Job Site SWMS', path: PATH_DASHBOARD.jobsiteSwms, icon: ICONS.dashboard,
                children: [
                    { title: 'Pool Types', path: PATH_DASHBOARD.poolTypes },
                    { title: 'Construction Types', path: PATH_DASHBOARD.constructionTypes }
                ]
            },

            // { title: 'Document Verification', path: PATH_DASHBOARD.docVerificationIndex, icon: ICONS.dashboard,
            //     children: [
            //         { title: 'White/Blue Cards', path: PATH_DASHBOARD.verifyCards },
            //         { title: 'QBCC License', path: PATH_DASHBOARD.verifyLicenses },
            //         { title: 'Public Liability', path: PATH_DASHBOARD.verifyInsurances },
            //         { title: 'Work Cover', path: PATH_DASHBOARD.verifyWorkcovers },
            //         { title: 'Test & Tag', path: PATH_DASHBOARD.verifyTesttag },
            //         { title: 'EWP Cards', path: PATH_DASHBOARD.verifyEwpcards },
            //         { title: 'Working Heights Cards', path: PATH_DASHBOARD.verifyWorkingheightscards },
            //     ]
            // },

        ]
    },
    "2": { // role id
        subheader: 'Builder',

        items: [ // these are menu items with child menus as well
            { title: 'To Do List', path: PATH_DASHBOARD.dash.checklist, icon: ICONS.dashboard },
            { title: 'Job Sites', path: PATH_DASHBOARD.dash.builder, icon: ICONS.jobsite },
            // { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
            { title: 'your team', path: PATH_DASHBOARD.user.yourteam, icon: ICONS.user },

        ]
    },

    "3": { // role id
        subheader: 'Subcontractor',

        items: [ // these are menu items with child menus as well
            { title: 'To Do List', path: PATH_DASHBOARD.dash.checklist, icon: ICONS.dashboard },
            { title: 'Job Sites', path: PATH_DASHBOARD.dash.subcontractor, icon: ICONS.jobsite },
            // { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
            { title: 'your team', path: PATH_DASHBOARD.user.yourteam, icon: ICONS.user },
            // { title: 'your builders', path: PATH_DASHBOARD.user.yourbuilders, icon: ICONS.builder }

        ]


    },

    "4": { // role id
        subheader: 'Employee',

        items: [ // these are menu items with child menus as well
             { title: 'To Do List', path: PATH_DASHBOARD.dash.checklist, icon: ICONS.dashboard },
            { title: 'Job Sites', path: PATH_DASHBOARD.dash.employee, icon: ICONS.jobsite },
            // { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },

        ]

    },
    "5": { // role id
        subheader: 'Office Admin',

        items: [ // these are menu items with child menus as well
            { title: 'To Do List', path: PATH_DASHBOARD.dash.checklist, icon: ICONS.dashboard },
            { title: 'Job Sites', path: PATH_DASHBOARD.dash.officeadmin, icon: ICONS.jobsite },
            // { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
            { title: 'your team', path: PATH_DASHBOARD.user.yourteam, icon: ICONS.user },

        ]

    },
    "6": { // role id
        subheader: 'Supervisor',

        items: [ // these are menu items with child menus as well
            { title: 'To Do List', path: PATH_DASHBOARD.dash.checklist, icon: ICONS.dashboard },
            { title: 'Job Sites', path: PATH_DASHBOARD.dash.supervisor, icon: ICONS.jobsite },
            // { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
            { title: 'your team', path: PATH_DASHBOARD.user.yourteam, icon: ICONS.user },

        ]

    },
    "7": { // role id
        subheader: 'Store Admin',

        items: [ // these are menu items with child menus as well
            { title: 'Dashboard', path: PATH_DASHBOARD.dash.storeAdmin, icon: ICONS.dashboard },
            { title: 'Give Aways', path: PATH_DASHBOARD.dash.storeAdminProducts, icon: ICONS.jobsite },
            { title: 'Claims', path: PATH_DASHBOARD.dash.storeAdminClaims, icon: ICONS.jobsite },
            // { title: 'Settings', path: PATH_DASHBOARD.dash.storeAdminSettings, icon: ICONS.jobsite },
            { title: 'messages', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },

        ]

    },

}

